module.exports = __webpack_public_path__ + "static/img/cocina_02.aefcc16b.jpeg";